import { RootState } from 'store/rootReducer';

export const TotalEarlySettlementContentSelector = (state: RootState) => state.content.totalEarlySettlement;
